import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=ca8d8bf0&scoped=true&"
var script = {}
import style0 from "./Privacy.vue?vue&type=style&index=0&id=ca8d8bf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8d8bf0",
  null
  
)

export default component.exports